import { AppTitle } from '../../../../../ui/text/AppTitle';

export function FormSectionTitle(props) {
  return <AppTitle level={4} style={{ fontSize: 16, marginBottom: 16 }} {...props} />;
}
